<template>
  <v-container fluid class="inventory-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn @click="runInventoryDialog" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Run
              </v-btn>

              <v-btn color="success" class="button-shadow mr-3" @click="isFindInventory=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="secondaryConst white--text" class="button-shadow mr-3" @click="deleteInventoryDialog">
                <v-icon class="mr-2">mdi-delete-forever</v-icon>
                Delete
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
                <v-btn 
                  v-show="inventory_data.length>0"
                  color="default" 
                  class="button-shadow mb-2 mr-0 mr-sm-2"
                >
                  <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                  Save
                </v-btn>
              </download-excel>
              <v-btn to="/inventoryjournal/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Journals
              </v-btn>
              <v-btn to="/inventorycount/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Counts
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="dataSelected"
              loading-text="Loading... Please wait"
              class="inventorys-table"
              sort-by="inventorynum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="itemHeaders"
              :items="inventory_data"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteInventory"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Inventory?
                    </v-card-title>
                    <v-card-text>
                      {{ new Date(delete_inventory.inventorydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteInventory = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteInventory(delete_inventory)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:5px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.itemimage="{ item }">
                    <v-img
                    v-if="item.itemimage" 
                    v-bind:src="item.itemimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.inventorynum="{ item }">
                <p class="two-line">{{ item.inventorytype  }}</p>
                <p class="two-line">{{ item.inventorynum  }}</p>
                <p v-if="item.inventorydate!=undefined" class="two-line">{{ new Date(item.inventorydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.itemquantity="{ item }">
                <p class="two-line">{{ item.itemquantity!=null ? item.itemquantity.toFixed(2): 0  }}</p>
              </template>
              <template v-slot:item.inventorystatus="{ item }">
                <v-chip
                  v-if="item.inventorystatus!=undefined"
                  :color="item.inventorystatus=='Completed' ? 'successConst white--text' : item.inventorystatus=='Partial' ? 'warning white--text' : 'secondaryConst white--text'" small>
                  {{ item.inventorystatus }}
                </v-chip>
              </template>
              <template v-slot:item.transdate="{ item }">
                {{ new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isRunInventory"
        persistent
        width="400px"
        max-width="400px"
        >
        <v-card>
          <v-card-title>
            <span class="text-h5">Run Inventory</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-menu
                    ref="menu_inventorydate"
                    v-model="menu_inventorydate"
                    :close-on-content-click="false"
                    :return-value.sync="run_inventory.inventorydate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="run_inventory.inventorydate"
                        label="Loading Date"
                        v-bind="attrs"
                        v-bind:value="run_inventory.inventorydate"
                        v-on="on"
                        single-line hint="Please choose the inventory date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="run_inventory.inventorydate"
                      no-title
                      scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_inventorydate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_inventorydate.save(run_inventory.inventorydate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                </v-col>
              </v-row>
            </v-container>
            </v-card-text>  
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isRunInventory = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="runInventory"
              >
                Save
              </v-btn>
            </v-card-actions>
          
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isFindInventory"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Inventory</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-select
                    :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                              return {text: x.locationname, value: x._id};
                            })"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-menu
                    ref="menu_ivtdate"
                    v-model="menu_ivtdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.ivtdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="find_query.ivtdate"
                        label="Inventory Date"
                        v-bind="attrs"
                        v-bind:value="find_query.ivtdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter inventory date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.ivtdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_ivtdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_ivtdate.save(find_query.ivtdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindInventory = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetQuery"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findInventory"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { formatStdDate } from '@/mixins/date';

export default {
  name: 'InventoryList',
  data() {
    return {
      config,
      snackbar: null,
      
      dialogAlert: false,
      dialogMessage: '',
      isFindInventory: false,
      isRunInventory: false,
      isDeleteInventory: false,

      menu_ivtdate: null,
      menu_inventorydate: null,
      
      itemPerPage: 500,
      delete_inventory: {},
      run_inventory: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemHeaders: [
        { text: 'Image', value: 'itemimage', sortable: false, width: '8%' },
        { text: 'Inventory Date', value: 'transdate', width: '12%'},
        { text: 'Location', value: 'locationname', width: '20%' },
        { text: 'Item', value: 'itemname'},
        { text: 'Cost', value: 'itemcost', width: '10%'},
        { text: 'Quantity', value: 'itemquantity', width: '10%'},
      ],
      inventory_data: [],
      dataSelected: [],

    }
  },
  computed: {
    ...mapState('Inventory', ['inventory', 'isReceiving', 'isDeleting']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Inventory', ["getInventoryRequest", "findInventoryRequest", "insertInventoryRequest", "deleteInventoryRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      if(this.inventory_data.length==0) return[];
      let json = this.inventory_data.map(trans=>{return {
        inventorydate: new Date(trans.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }),
        location: trans.locationname,
        item: trans.itemname,
        quantity: trans.itemquantity.toFixed(2),
        cost: trans.itemcost.toFixed(2),
        value: (trans.itemcost * trans.itemquantity).toFixed(2),
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'inventory-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    editItem(item) {
      this.$router.push({ name: 'InventoryEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'InventoryPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'InventoryView', params: item });
    },
    runInventoryDialog() {
      let date = formatStdDate(new Date());
      this.run_inventory = {inventorydate: date};
      this.isRunInventory = true;
    },
    async runInventory(){
      this.isRunInventory = false;
      let result = await this.insertInventoryRequest(this.run_inventory);
      this.inventory_data = Object.assign([], result.transactions);
      this.inventory_data.sort((a,b) =>{
        if (b.locationcode > a.locationcode) return -1;
        if (a.locationcode < b.locationcode) return 1;
        return 0;
      });  
    },
    async findInventory(){
      this.isFindInventory = false;
      if(Object.keys(this.find_query).length==0){
        await this.getInventoryRequest();
        this.inventory_data = Object.assign([], this.inventory.transactions);
        this.inventory_data.sort((a,b) =>{
          if (b.locationcode > a.locationcode) return -1;
          if (a.locationcode < b.locationcode) return 1;
          return 0;
        });
      }
      else{
        let result = await this.findInventoryRequest(this.find_query);
        this.inventory_data = Object.assign([], result.transactions);
        this.inventory_data.sort((a,b) =>{
          if (b.locationcode > a.locationcode) return -1;
          if (a.locationcode < b.locationcode) return 1;
          return 0;
        });
      }
    },
    async resetQuery(){
      this.find_query = {};
    },
    async deleteInventory(item) {
      await this.deleteInventoryRequest({_id: item._id});
      await this.getInventoryRequest();
      this.inventory_data = Object.assign([], this.inventory.transactions);
      this.isDeleteInventory = false;
    },
    deleteInventoryDialog() {
      this.isDeleteInventory = true;
      this.delete_inventory = {
        _id: this.inventory._id,
        inventorydate: this.inventory.inventorydate,
      }
    },
  },
  async created () {
    if(Object.keys(this.inventory).length==0) await this.getInventoryRequest();
    this.inventory_data = Object.assign([], this.inventory.transactions);
    this.inventory_data.sort((a,b) =>{
          if (b.locationcode > a.locationcode) return -1;
          if (a.locationcode < b.locationcode) return 1;
          return 0;
    });

    if(this.locations.length==0) await this.getLocationsRequest();

  },
}
</script>

<style src="./List.scss" lang="scss"></style>
